<script setup lang="ts">
import { inject } from 'vue'
import { GeoImagesViewModelKey } from '../keys/GeoImagesViewModel.key'
import { BandTypeEnum } from '../../../../@core/lidar/domain/enums/BandType.enum'
import Breadcrumb from '../../../../components/ui/breadcrumb/Breadcrumb.vue'
import MapBandRow from './MapBandRow.vue'
import Button from '../../../../components/Button/Button.vue'
import Message from '../../../../components/ui/message/Message.vue'

const vm = inject(GeoImagesViewModelKey)!

function updateBandMapping(bandType: BandTypeEnum, value: string) {
	vm.bandMapping.value[bandType] = value
}
</script>

<template>
	<div>
		<div class="flex justify-center mb-4">
			<Breadcrumb
				:value="vm.formStep.value"
				:crumbs="vm.breadcrumbCrumbs.value"
				@input="vm.formStep.value = $event"
			/>
		</div>

		<h2 class="text-H5 font-bold mb-2">Definição das bandas</h2>

		<p class="text-sm text-gray-600 mb-4">
			Identifique as bandas para a realização dos cálculos de índices de vegetação. A definição não
			é obrigatória, então caso as bandas não sejam identificadas o cadastro da imagem seguirá
			normalmente porém os índices de vegetação não serão calculados no processamento.
		</p>

		<div class="flex flex-col gap-4">
			<MapBandRow
				label="Red"
				:options="vm.bandDropdownOptions.value[BandTypeEnum.RED]"
				:value="vm.bandMapping.value[BandTypeEnum.RED]"
				@input="updateBandMapping(BandTypeEnum.RED, $event)"
			/>
			<MapBandRow
				label="Green"
				:options="vm.bandDropdownOptions.value[BandTypeEnum.GREEN]"
				:value="vm.bandMapping.value[BandTypeEnum.GREEN]"
				@input="updateBandMapping(BandTypeEnum.GREEN, $event)"
			/>
			<MapBandRow
				label="Blue"
				:options="vm.bandDropdownOptions.value[BandTypeEnum.BLUE]"
				:value="vm.bandMapping.value[BandTypeEnum.BLUE]"
				@input="updateBandMapping(BandTypeEnum.BLUE, $event)"
			/>
			<MapBandRow
				label="NIR"
				:options="vm.bandDropdownOptions.value[BandTypeEnum.NIR]"
				:value="vm.bandMapping.value[BandTypeEnum.NIR]"
				@input="updateBandMapping(BandTypeEnum.NIR, $event)"
			/>
		</div>

		<div class="mt-4">
			<Message
				type="info"
				description="Para calculo do índice é necessário identificar todas as bandas necessárias para cada índice (NDVI, GNDVI, EVI, SAVI, MPRI)"
			/>
		</div>

		<div class="flex gap-4 mt-4">
			<Button
				label="cancelar"
				color="trv-primary"
				semantic-class="mini"
				outlined
				@click="vm.goBackToStep0()"
			/>
			<Button
				label="salvar"
				color="trv-default"
				semantic-class="mini"
				:disabled="vm.disableSaveButton.value"
				:loading="vm.disableSaveButton.value"
				@click="vm.saveClick()"
			/>
		</div>
	</div>
</template>
